import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DefaultTaskRoutingModule } from './default-task-routing.module';
import { DefaultTaskComponent } from './default-task.component';
import { MatButtonModule, MatCardModule, MatDividerModule, MatIconModule, MatInputModule, MatTooltipModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  declarations: [DefaultTaskComponent],
  imports: [
    CommonModule,
    BrowserModule,
    DefaultTaskRoutingModule,
    MatCardModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatInputModule
  ],
  exports: [DefaultTaskComponent]
})
export class DefaultTaskModule { }
